module.exports = __webpack_public_path__ + "static/media/ny-che-big-mobile.b8729266.png";